import * as React from 'react';
import classnames from 'classnames';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Text, { Props as TextProps } from '../Text/Text';
import Visibility from '../Visibility/Visibility';
import VisibilityContainer from '../Visibility/VisibilityContainer';

export type TypeTableSort = 'asc' | 'desc';

export interface Props extends TextProps {
  /**
   * Indicates that the cell is sortable, the provided value is what is
   * indicated as the sort direction when clicked.
   */
  sortable?: TypeTableSort;
  /**
   * When provided, it indicates that this table is currently being
   * sorted in the given direction.
   */
  sorted?: TypeTableSort;
}

/**
 * The header cell. Should be a direct descendant of the TableHeaderRow component.
 */
const TableHeaderCell: React.FunctionComponent<Props> = (props: Props) => {
  const { align, children, sortable, sorted } = props;
  const classes = classnames('Table__header-cell', {
    'Table__header-cell--sortable': sortable,
  });

  return (
    <Text { ...props }
        Component="th"
        className={ classes }>
      <VisibilityContainer
          alignChildrenHorizontal={ align }
          alignChildrenVertical="middle"
          direction="horizontal"
          enabled={ !!sortable }
          gap="x2">
        <Flex>
          { children }
        </Flex>

        { sortable && (
          <Visibility visible={ sorted ? true : undefined }>
            <Icon name={
              (sorted === 'asc' && 'ArrowUp') ||
              (sorted === 'desc' && 'ArrowDown') ||
              (sortable === 'asc' && 'ArrowUp') ||
              (sortable === 'desc' && 'ArrowDown') ||
              'ArrowDown'
            } />
          </Visibility>
        ) }
      </VisibilityContainer>
    </Text>
  );
};

export default TableHeaderCell;
